import {bignumber, BigNumber, multiply} from "mathjs";
import {DENSITY_OF_WATER_AT_BASE_KGM3, divide} from "./api-mpms";
import {DensityUnit, DensityUnitApi, DensityUnitKgm3, DensityUnitRelative} from "./unit/density-unit";
import {UnitValue} from "./unit/unit";

export class Density extends UnitValue<DensityUnit> {

  to(unit: DensityUnit): Density {
    if (unit === DensityUnitApi) {
      const convertedValue = Density.convertToAPI(this)
      return new Density(convertedValue, unit)
    } else if (unit === DensityUnitKgm3) {
      const convertedValue = Density.convertToKgm3(this)
      return new Density(convertedValue, unit)
    } else if (unit === DensityUnitRelative) {
      const convertedValue = Density.convertToRelativeDensity(this)
      return new Density(convertedValue, unit)
    } else {
      throw new Error("Unknown unit: " + unit);
    }
  }

  rounded(): Density {
    const roundedValue = this.roundedValue()
    return new Density(roundedValue, this.unit)
  }

  static convertToKgm3(density: Density): BigNumber {
    if (density.unit === DensityUnitKgm3) {
      return density.value
    } else if (density.unit === DensityUnitRelative) {
      return multiply(density.value, DENSITY_OF_WATER_AT_BASE_KGM3) as BigNumber
    } else if (density.unit === DensityUnitApi) {
      const divisor = density.value.add(bignumber(("131.5")))
      const divValue = divide(bignumber("141.5"), divisor)
      return divValue.times(DENSITY_OF_WATER_AT_BASE_KGM3)
    } else {
      throw new Error("Unknown unit: " + density.unit)
    }
  }

  static convertToAPI(density: Density): BigNumber {
    if (density.unit === DensityUnitApi) {
      return density.value
    } else if (density.unit === DensityUnitRelative) {
      throw new Error("Unable to convert relative density to API density")
    } else if (density.unit === DensityUnitKgm3) {
      const divisor = divide(density.value, DENSITY_OF_WATER_AT_BASE_KGM3)
      const divValue = divide(bignumber("141.5"), divisor)
      return divValue.minus(bignumber("131.5"))
    } else {
      throw new Error("Unknown unit: " + density.unit)
    }
  }

  static convertToRelativeDensity(density: Density): BigNumber {
    if (density.unit === DensityUnitRelative) {
      return density.value
    } else if (density.unit === DensityUnitApi) {
      throw new Error("Unable to convert API density to relative density")
    } else if (density.unit === DensityUnitKgm3) {
      return divide(density.value, DENSITY_OF_WATER_AT_BASE_KGM3)
    } else {
      throw new Error("Unknown unit: " + density.unit)
    }
  }
}
